(() => {
  let cleaning = false;
  let cleanupTimer = 0;
  let cleanupRetryTimer = 0;

  const getBundleRoot = (form) => {
    const handle = form.dataset.productHandle || '';
    return Array.from(document.querySelectorAll('[data-vg-bundle-options]'))
      .find((root) => root.dataset.productHandle === handle && !root.hidden);
  };

  const getSelections = (root) => {
    if (!root || typeof root.vgBundleSelections !== 'function') return [];
    return root.vgBundleSelections();
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest && event.target.closest('form[data-product-form]');
    if (!form) return;

    const root = getBundleRoot(form);
    const selections = getSelections(root);
    if (!selections.length) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = button && button.querySelector('[data-add-to-cart-text]');
    const originalText = buttonText ? buttonText.textContent : '';
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);
    if (selections.length !== 1 || !selections[0].nativeBundleVariantId) return;
    const items = [{
      id: Number(selections[0].nativeBundleVariantId),
      quantity
    }];

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    if (buttonText) buttonText.textContent = 'Adding bundle…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || 'The bundle could not be added.');
      window.location.assign('/cart');
    } catch (error) {
      document.dispatchEvent(new CustomEvent('cart:error', {
        detail: { errorMessage: error.message || 'The bundle could not be added.' }
      }));
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      if (buttonText) buttonText.textContent = originalText;
    }
  }, true);

  const reconcileCart = async () => {
    if (cleaning) return;
    cleaning = true;
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      const bases = new Set();

      cart.items.forEach((item) => {
        const properties = item.properties || {};
        if (properties._vg_bundle_role === 'base' && properties._vg_bundle_id) {
          bases.add(String(properties._vg_bundle_id));
        }
      });

      const updates = {};
      cart.items.forEach((item) => {
        const properties = item.properties || {};
        if (
          properties._vg_bundle_role === 'addon'
          && properties._vg_bundle_id
          && !bases.has(String(properties._vg_bundle_id))
        ) {
          updates[item.key] = 0;
        }
      });

      if (!Object.keys(updates).length) return;
      const update = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates })
      });
      if (update.ok) window.location.reload();
    } finally {
      cleaning = false;
    }
  };

  const scheduleCleanup = (delay = 650, retryDelay = 0) => {
    window.clearTimeout(cleanupTimer);
    window.clearTimeout(cleanupRetryTimer);
    cleanupTimer = window.setTimeout(reconcileCart, delay);
    if (retryDelay > delay) {
      cleanupRetryTimer = window.setTimeout(reconcileCart, retryDelay);
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('[data-remove-item]')) {
      scheduleCleanup(700, 1800);
    }
  }, true);

  document.addEventListener('cart:updated', () => scheduleCleanup(250));

  if (window.location.pathname === '/cart') {
    window.addEventListener('pageshow', () => scheduleCleanup(100));
  }
})();
